/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IManageSecurityMatrixScope extends angular.IScope {
        model: models.ManageSecurityMatrixModel;
    }


    export class ManageSecurityMatrixController implements IController {
        constructor(
            private scope: IManageSecurityMatrixScope,
            securityMatrixService: services.SecurityMatrixService,
            $routeParams: angular.route.IRouteParamsService,
            systemLevelService: services.SystemLevelService,
            deleteService: services.DeleteService,
            processConfigurtaionService: services.ProcessConfigurationService) {
            var processConfigId = $routeParams["id"];

            this.scope.model = new models.ManageSecurityMatrixModel(processConfigId, securityMatrixService, systemLevelService, deleteService, processConfigurtaionService);
        }
    }
}

warsApp.registerController('ManageSecurityMatrixController', ['$scope', 'securityMatrixService', '$routeParams', 'systemLevelService', 'deleteService', 'processConfigurationService']);